import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, NavigationStart } from "@angular/router";
import { UserService } from '../../services/user.service';
import { nodeTypes, appLabels } from '../../../app/app-constant';
import { Subscription } from 'rxjs';
import { routes } from '../../../app/routes.constant';
import { LoginService } from '../login/login.service';
import { HeaderService } from './header.service';
import { TagsService } from '../../services/tags.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Input() userLoggedIn: boolean;
  //@Output() logout = new EventEmitter<any>();
  activeRoute: String;
  //@Input() nodeName: String;
  //nodeName: String;
  nodeName: String;
  nodeType: String;
  localStorage = localStorage;
  userName: String;
  nodeTypes: any = nodeTypes;
  private userDataSubscription: Subscription;
  routes: any = routes;
  showUsernameDropdown: boolean = false;
  showSubMenu: Boolean = false;
  showMenuItem = false;
  landingRoute = '';
  displayName = '';
  lastLogin = '';
  appLabels = appLabels;

  constructor(private router: Router, private userService: UserService,  
    private loginService: LoginService, private headerService: HeaderService, 
    private tagsService: TagsService) {
    const that = this;
    this.activeRoute = (userService.nodeType == nodeTypes.ADMIN) ? routes.USERS : routes.HOLD_TRANSACTIONS_HOLDINGS;
    this.landingRoute = this.loginService.getLandingRoute();
    router.events.forEach((event) => {
      if(event instanceof NavigationStart) {
        that.activeRoute = event.url;
      }
      // NavigationEnd
      // NavigationCancel
      // NavigationError
      // RoutesRecognized
    });

    this.nodeName = userService.nodeName;
    this.nodeType = userService.nodeType;
    this.userName = userService.userName;
    that.displayName = userService.displayName;
    that.lastLogin = userService.lastLogin;

    this.userDataSubscription = this.userService.userDataSub.subscribe(
      (val) => {
        //console.log('userDataSubscription', val)
        if(val == 'Y') {
          that.nodeName = userService.nodeName;
          that.nodeType = userService.nodeType;
          that.userName = userService.userName;
          that.displayName = userService.displayName;
          that.lastLogin = userService.lastLogin;
        }
      }
    );
  }

  ngOnInit() {
    //console.log(this.localStorage.getItem('username'));
  }

  routeNavigate(routePath, menuLabel) {
    this.router.navigate([routePath]);

    this.tagsService.link({
      "event_action" : "tab",
      "event_content": "header menu item : " + menuLabel
    });
  }

  userLogout() {
    let that = this;
    //localStorage.removeItem("loggedIn");//#toRemove
    //this.loginService.loggedIn = null;//#toRemove
    //this.router.navigate(['/login']);//#toRemove
    this.loginService.logout()
      .subscribe( res => {
          //console.log(res);
          //this.router.navigate(['/login']);
          window.location.href = that.userService.hsbcNetUrl;
        },
        error => {
          //console.log(error);
          window.location.href = that.userService.hsbcNetUrl;
        });

    this.tagsService.link({
      "event_action" : "button click",
      "event_content": "logout"
    });
  }

  /* refresh() {//console.log(this.router.url);
    if(this.router.url == routes.SEC_MASTER){
      this.secMasterService.secMasterDataSub.next('Y');
    } else if(this.router.url == routes.HOLD_TRANSACTIONS_HOLDINGS){
      this.transactionsService.holdingTxnSub.next('Y');
    } else if([nodeTypes.CUSTOMER, nodeTypes.AUDITOR, nodeTypes.REGULATOR].indexOf(this.userService.nodeType) > -1) {
      if(this.router.url == routes.BUY_TRANSACTIONS || this.router.url == routes.SELL_TRANSACTIONS) {
        this.transactionsService.dashboardTxnSub.next('Y');
      }
    }
  } */

  refresh() {
    this.headerService.refresh(this.router.url);

    this.tagsService.link({
      "event_action" : "button click",
      "event_content": "refresh icon"
    });
  }

  onClickOutside(event:Object) {
    if(event && event['value'] === true) {
      this.showUsernameDropdown = false;
    } else {
      //console.log('clicked inside');
    }
  }

  navigateToHelp() {
    this.router.navigate([routes.HELP]);

    this.tagsService.link({
      "event_action" : "button click",
      "event_content": "help icon"
    });
  }

}
